/// BUILD INFO
/// GitBranch = "HEAD";
/// GitUser = "VssAdministrator";
/// GitPC = "runnervm72i71";
/// GitDate = "Thu 01/22/2026 ";
/// GitTime = "10:57 PM";
/// PUBLISH = "PRODAZURE";
export const endPoint = "https://api.smartenotary.com";
export const glanceURL = "https://www.glancecdn.net/cobrowse/CobrowseJS.ashx?group=20408&site=production";
export const glanceSite = "production";
